function DeviceAction() {
    "use strict";

    this.__type = 'DeviceAction:www.veritracks.com';
    this.Id = -1;
    this.Version = 0;

    this.ActionDateUTC = new Date();
    this.ActionStatus = -1;
    this.ActionType = -1;
    //this.DeviceId = -1;
}
if (typeof exports !== 'undefined') {
    module.exports = DeviceAction;
}